export const getRowClass = (props) => {
  const className = [];

  if (props?.data?.isGroup) {
    className.push('custom-row-group');
  }

  if (props?.data?.id === 'load-more') {
    className.push('span-load-more-cell');
  }

  if (props?.data?.original?.noContacts) {
    className.push('no-contacts');
  }

  if (props?.data?.original?.lastRow) {
    className.push('last-row');
  }

  return className.join(' ');
};

export const processCellForClipboard = (params) => {
  if (params.column.getColId() === 'contactOf') {
    return params.value?.map?.((contact) => contact.name).join(', ') || '';
  }

  if (params.column.getColId() === 'intros') {
    return params.value?.map?.((intro) => intro.offererName).join(', ') || '';
  }

  if (params?.node?.data?.id === 'load-more') {
    return '';
  }

  return params.value;
};

export const getCellClass = (params) => {
  if (params?.data?.original?.noContacts && params?.column?.getColId() !== 'contactOf') {
    return 'ag-cell-no-contacts';
  }

  return '';
};
